import React from "react";
import style from "../../../../src/assets/css/modules/contact-us/online-link.css";
import { Link } from "react-router-dom";
import { ButtonConfig, Layouts } from "../../../constants/Constants";
import { getLayout } from "../../../layout/Layout";

const ContactUsChat = (props) => {

  const onlivechatClick = () => {
    const button = document.querySelector('#embeddedMessagingConversationButton');
    button?.click('#embeddedMessagingConversationButton');
  };

  return (
    <div id="contactUsChat">
        <Link to="/contactus" id={getLayout() === Layouts.HOL ? "" :ButtonConfig.LiveChatContactUs} className={style.disabledchat} onClick={(e) => onlivechatClick(e)}>
          <i className="icon-functional-chat" />
          <span className={style.ChatBusinessHour}>{props.linkText}
            </span>
        </Link>
    </div>
  );
};

export default ContactUsChat;